const BASE_API = process.env.REACT_APP_ROUTE_API;
const token = localStorage.getItem('token');
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    index: async () => {
        try {
          const req = await fetch(`${BASE_API}site/home`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? [];
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return(error);
        }
      },
      contato: async (data) => {
      try {
        try {
          let req;
          req = await fetch(`${BASE_API}site/contato`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data) 
          });
          
          const json = await req.json()
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return error;
        }
      } catch (error) {
        return(error);
      }
    },
};